import { NavItem } from './nav-item';

export class NavGroup {
    items: NavItem[];
    isVisible: boolean;

    constructor(items: NavItem[],isVisible?: boolean) {
        this.items = items;
        this.isVisible = isVisible;
    }
}
